import { Models } from '@rematch/core';
import { im } from './im';

export interface RootModel extends Models<RootModel> {
  im: typeof im;
}

export const models: RootModel = { im };
